import { Component, OnInit, AfterViewInit, OnDestroy } from '@angular/core';
import * as $ from 'jquery';

@Component({
  selector: 'pm-reportes',
  templateUrl: './reportes.component.html',
  styleUrls: ['./reportes.component.sass']
})
export class ReportesComponent implements OnInit, AfterViewInit, OnDestroy {
  constructor() {}

  ngOnInit() {}

  ngAfterViewInit() {
    $('a[rel=reportes]').addClass('selected');
  }

  ngOnDestroy() {
    $('a[rel=reportes]').removeClass('selected');
  }
}
